import { FEEDBACK_GENERIC_CHANNEL_ID, CUSTOMER_PORTAL_GENERIC_CHANNEL_ID, FB_MESSENGER_GENERIC_CHANNEL_ID, COMMENTS_GENERIC_CHANNEL_ID, FORMS_GENERIC_CHANNEL_ID, EMAIL_GENERIC_CHANNEL_ID, LIVE_CHAT_GENERIC_CHANNEL_ID, WHATSAPP_GENERIC_CHANNEL_ID, CALLING_GENERIC_CHANNEL_ID, SMS_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import { EmailIcon, MessagesIcon, SocialFacebookMessengerIcon, FormsIcon, SocialWhatsappIcon, CallingIcon, SmsIcon } from 'foundations-assets';
import { ENGAGEMENT_DETAILS_MESSAGE } from 'conversations-message-history/engagement-details-message/constants/engagementDetailsMessageType';
import { THREAD_COMMENT } from 'conversations-message-history/comment-message/constants/messageTypes';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @description The icon to render for channels we haven't made an intentional
 * decision on.
 */
const FallbackIcon = MessagesIcon;
export const channelIconComponentMap = {
  [EMAIL_GENERIC_CHANNEL_ID]: EmailIcon,
  [LIVE_CHAT_GENERIC_CHANNEL_ID]: MessagesIcon,
  [FB_MESSENGER_GENERIC_CHANNEL_ID]: SocialFacebookMessengerIcon,
  [FORMS_GENERIC_CHANNEL_ID]: FormsIcon,
  [WHATSAPP_GENERIC_CHANNEL_ID]: SocialWhatsappIcon,
  [COMMENTS_GENERIC_CHANNEL_ID]: MessagesIcon,
  [THREAD_COMMENT]: MessagesIcon,
  [ENGAGEMENT_DETAILS_MESSAGE]: MessagesIcon,
  [CUSTOMER_PORTAL_GENERIC_CHANNEL_ID]: FallbackIcon,
  [FEEDBACK_GENERIC_CHANNEL_ID]: FallbackIcon,
  [CALLING_GENERIC_CHANNEL_ID]: CallingIcon,
  [SMS_GENERIC_CHANNEL_ID]: SmsIcon
};
export const IconFallback = () => /*#__PURE__*/_jsx(Tooltip, {
  title: I18n.text('conversations-inbox-message-history.common-message.unknownChannelMessage'),
  children: /*#__PURE__*/_jsx(FallbackIcon, {
    "data-test-id": "message-header-channel-fallback-icon"
  })
});
IconFallback.displayName = 'IconFallback';
export const ChannelIcon = ({
  genericChannelId,
  channelName,
  'data-test-id': dataTestId = 'message-header-channel-icon'
}) => {
  const Icon = channelIconComponentMap[genericChannelId];
  if (channelName && Icon) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: channelName,
      children: /*#__PURE__*/_jsx(Icon, {
        "data-test-id": dataTestId,
        size: "200"
      })
    });
  }
  return /*#__PURE__*/_jsx(IconFallback, {});
};
ChannelIcon.displayName = 'ChannelIcon';